export default __webpack_public_path__ + "static/media/2pos.82573524.jpg";